import { Environment } from '@robinpowered/dashboard-apps-common';

const {
  NODE_ENV,
  REACT_APP_ROBIN_ENV,
  REACT_APP_DASHBOARD_URL,
  REACT_APP_DASHBOARD_API_URL,
  REACT_APP_ROBIN_INTERCOM_APP_ID,
  REACT_APP_SENTRY_DSN_SHELL,
  REACT_APP_FEATURE_FLAG_URL,
  REACT_APP_COOKIE_NAME,
  REACT_APP_GQL_URL,
  REACT_APP_NAME_SHELL,
  REACT_APP_VERSION_SHELL,
  REACT_APP_AMPLITUDE_API_KEY_SHELL,
} = process.env;

type Config = {
  env: Environment;
  robinEnv: Environment;
  dashboardUrl: string;
  dashboardApiUrl: string;
  robinIntercomAppId: string;
  sentryDsn: string;
  featureFlagUrl: string;
  sessionCookieName: string;
  gqlUrl: string;
  appName: string;
  appVersion: string;
  amplitudeApiKey: string;
};

[
  'NODE_ENV',
  'REACT_APP_ROBIN_ENV',
  'REACT_APP_DASHBOARD_API_URL',
  'REACT_APP_ROBIN_INTERCOM_APP_ID',
  'REACT_APP_SENTRY_DSN_SHELL',
  'REACT_APP_FEATURE_FLAG_URL',
  'REACT_APP_COOKIE_NAME',
  'REACT_APP_GQL_URL',
  'REACT_APP_NAME_SHELL',
  'REACT_APP_VERSION_SHELL',
  'REACT_APP_AMPLITUDE_API_KEY_SHELL',
].forEach((key) => {
  if (process.env.NODE_ENV !== 'test' && process.env[key] === undefined) {
    throw new Error(`Missing ${key} on '.`);
  }
});

export const config: Config = {
  env: NODE_ENV as Environment,
  dashboardUrl: REACT_APP_DASHBOARD_URL as string,
  dashboardApiUrl: REACT_APP_DASHBOARD_API_URL as string,
  robinIntercomAppId: REACT_APP_ROBIN_INTERCOM_APP_ID as string,
  robinEnv: REACT_APP_ROBIN_ENV as Environment,
  sentryDsn: REACT_APP_SENTRY_DSN_SHELL as string,
  featureFlagUrl: REACT_APP_FEATURE_FLAG_URL as string,
  sessionCookieName: REACT_APP_COOKIE_NAME as string,
  gqlUrl: REACT_APP_GQL_URL as string,
  appName: REACT_APP_NAME_SHELL as string,
  appVersion: REACT_APP_VERSION_SHELL as string,
  amplitudeApiKey: REACT_APP_AMPLITUDE_API_KEY_SHELL as string,
};

/* eslint-disable no-console */
if (config.env === 'development') {
  console.groupCollapsed('Started app with config');
  console.table(config);
  console.groupEnd();
}
/* eslint-enable no-console */
